import React from 'react';
import PropTypes from 'prop-types';
import { ARCHETYPE_CONTENT, getBookArchetype } from '../../shared/book-archetype-helpers';
import styles from './PlanGraphSlideV9.css';

function PlanGraphSlideV9({ results }) {
    const { chaptersFor, chapters } = ARCHETYPE_CONTENT[getBookArchetype(results.userResponses)];

    return (
        <section className={styles.root}>
            <h2 className={styles.heading}>Your book has a cover. The pages are still empty.</h2>
            <p className={styles.subheading}>Seven chapters for <strong>{chaptersFor}.</strong></p>
            <ol className={styles.chapters}>
                {chapters.map((chapter, index) => (
                    <li key={chapter} className={styles.chapter}>
                        <span className={styles.chapterInfo}>
                            <span className={styles.chapterNumber}>Chapter {index + 1}</span>
                            <span className={styles.chapterTitle}>{chapter}</span>
                        </span>
                        {index === 0 ? (
                            <span className={styles.badge}>Ready to draft</span>
                        ) : (
                            <span className={styles.progress}>0%</span>
                        )}
                    </li>
                ))}
            </ol>
        </section>
    );
}

PlanGraphSlideV9.propTypes = {
    results: PropTypes.shape({ userResponses: PropTypes.array }).isRequired
};

export {
    PlanGraphSlideV9
};
